export default class ShareButton {
    static init() {
        const isNeosBackend = document.body.classList.contains('neos-backend');
        if (isNeosBackend) return;

        // Delegated click handler for share buttons
        window.addEventListener('click', (e) => {
            const shareButton = e.target.closest('.share-button');
            if (!shareButton) return;

            // Read the absolute or relative share URL directly from the data attribute
            const shareUrl = shareButton.dataset.url;
            if (!shareUrl) return;

            navigator.clipboard.writeText(shareUrl)
                .then(() => {
                    shareButton.classList.add('share-button--done');
                    setTimeout(() => {
                        shareButton.classList.remove('share-button--done');
                    }, 1500);
                })
                .catch(err => {
                    console.error('Failed to copy URL to clipboard:', err);
                    shareButton.classList.add('share-button--error');
                    setTimeout(() => {
                        shareButton.classList.remove('share-button--error');
                    }, 1500);
                });
        });
    }
}
